{
    "LicenseManagement_Title": "Enterprise Licence Management",
    "LicenseManagement_Heading_License": "Licence - Teams",
    "LicenseManagement_Heading_Quantity": "Quantity",
    "LicenseManagement_Essentials": "Essentials",
    "LicenseManagement_Essentials_MST": "CXA Standard",
    "LicenseManagement_Professional": "Professional",
    "LicenseManagement_Professional_MST": "CXA Premium",
    "LicenseManagement_Enterprise": "Enterprise",
    "LicenseManagement_Enterprise_MST": "CXA Advanced (Historic)",
    "LicenseManagement_CallCentreAgent": "Call Centre Agent",
    "LicenseManagement_CallCentreAgent_MST": "CXA Premium",
    "LicenseManagement_CallCentreSupervisor": "Call Centre Supervisor",
    "LicenseManagement_CallCentreSupervisor_MST": "CXA Advanced",
    "LicenseManagement_CXIntegration": "CX Integration",
    "LicenseManagement_Validation_Number": "Must be a valid number",
    "LicenseManagement_Validation_Limit": "Exceeds CME Licence Cap. Must be less than or equal to {}",
    "LicenseManagement_Validation_Limit_Reached": "Exceeds CME Licence Cap. No more licences available",
    "LicenseManagement_Validation_MAX_LIMIT": "Number exceeds maximum allowed number",
    "LicenseManagement_Validation_POSITIVE_NUMBER": "Number must be positive",
    "NAME": "LicenseManagement"
}
